<template>
    <b-card>
        <div>
            <tarefas-aprovacao-almoxarifado-modal :isVisualizacao="isVisualizacao"
                v-if="showTarefaAprovacaoAlmoxarifadoModal" :pedido="this.selectedItem.pedido" :tarefa="selectedItem"
                uri="/aprovacao-almoxarifado" propQuantidade="quantidadeAprovada"
                @tarefaAlmoxarifadoFinalizado="fecharTarefaAprovacaoAlmoxarifado"
                @close="fecharTarefaAprovacaoAlmoxarifado"
                :prefix="prefix + title + ' > '"></tarefas-aprovacao-almoxarifado-modal>

            <ModalLogin :id="this.selectedItem.pedido.id" v-if="showModalLoginModal"
                @tarefaRetirada="selectedItem = $event" @usuarioAutenticado="usuarioAuthenticated = $event"
                @abrirTarefaRetirada="abrirModalRetirada" :tarefa="selectedItem" :prefix="prefix + title + ' > '"
                @close="showModalLoginModal = false">
            </ModalLogin>

            <TarefaRetiradaModal :prefix="prefix + title + ' > '" :tarefa="selectedItem"
                :isVisualizacao="isVisualizacao" :pedido="this.selectedItem.pedido" uri="/tarefa-retirada"
                @tarefaRetiradaFinalizado="tarefaRetiradaFinalizado" v-if="showTarefaRetiradaModal"
                @close="tarefaRetiradaFinalizado" :responsavel="usuarioAuthenticated">
            </TarefaRetiradaModal>

            <TarefasAprovacaoSolicitanteModal :tarefa="selectedItem" :isVisualizacao="isVisualizacao"
                :numeroPedido="this.selectedItem.pedido.id" uri="/aprovacao-solicitante"
                @tarefaAprovacaoSolicitanteFinalizado="tarefaAprovacaoSolicitanteFinalizado
                " :prefix="prefix + title + ' > '" v-if="showTarefaAprovacaoSolicitanteModal"
                :pedido="this.selectedItem.pedido" @close="tarefaAprovacaoSolicitanteFinalizado">
            </TarefasAprovacaoSolicitanteModal>
        </div>

        <b-card bg-variant="light">
            <b-form-row @keyup.enter="load">
                <lg-form-input invalidFeedback="O número produto deve ser informado!" description=""
                    v-model="form.numeroTarefa" label="Número:" sm="2" />

                <lg-form-select @input="load" style="z-index: 21" v-model="form.tarefa"
                    :loadFunction="listTipoTarefaPedido" labelFormGroupBind="Tipo Tarefa:" label="descricao"
                    description="" filterList="true" lg="4" sm="4" />

                <b-col lg="4" sm="12" class="text-left">
                    <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativaTarefa"
                        @onselect="handleSelectUnidadeAdministrativaTarefa" v-model="form.departamentoResponsavel"
                        :podeMudarDepartamento="temPrivilegioSelecionarUA() || temPrivilegioConfigurarAlmoxarifado()"
                        :podeApagarDepartamento="temPrivilegioSelecionarUA() || temPrivilegioConfigurarAlmoxarifado()"
                        invalidFeedback="Informe uma unidade administrativa!" :prefix="prefix + title + ' > '">
                    </lg-finder-page-unidade-administrativa>
                </b-col>
                <b-col cols="2"></b-col>


                <lg-form-select @input="load" style="z-index: 20" v-model="form.status" :loadFunction="listStatus"
                    labelFormGroupBind="Status:" label="descricao" description="" filterList="true" class="nowrap"
                    lg="6" sm="4" />

                <b-col lg="6" sm="12" class="text-left">
                    <lg-finder-page-almoxarifado id="finderAlmoxarifadoTarefa"
                        @onselect="handleSelectAlmoxarifadoTarefa" v-model="form.almoxarifadoTarefa"
                        invalidFeedback="Informe um almoxarifado!" :prefix="prefix + title + ' > '">
                    </lg-finder-page-almoxarifado>
                </b-col>


                <b-col lg="5" sm="12" class="text-left">
                    <LgFinderPagePessoa id="finderResponsavelTarefaPedido" label="Responsável:"
                        @onselect="handleSelectResponsavelTarefa" v-model="form.responsavel"
                        invalidFeedback="Informe um responsável!" :prefix="prefix + title + ' > '" />
                </b-col>


                <b-col lg="5" sm="12" class="text-left">
                    <LgFinderPageProduto id="finderProdutoTarefaDevolucao" @onselect="handleSelectProduto"
                        v-model="form.produto" invalidFeedback="Informe um produto!" :prefix="prefix + title + ' > '" />
                </b-col>
                <b-col lg="5" sm="12" class="text-left">
                    <lg-finder-page-unidade-administrativa id="finderDepartamentoSolicitante"
                        :podeMudarDepartamento="temPrivilegioConfigurarAlmoxarifado()"
                        :podeApagarDepartamento="temPrivilegioConfigurarAlmoxarifado()"
                        @onselect="handleSelectUnidadeSolicitante" v-model="form.departamentoSolicitante"
                        invalidFeedback="Informe uma unidade administrativa!" :prefix="prefix + title + ' > '"
                        :label="'Unidade Solicitante:'">
                    </lg-finder-page-unidade-administrativa>

                </b-col>

                <b-col class="text-right ">
                    <b-button id="pesquisarTarefaPedido" class="mr-2 my-2" size="sm" style="height: 20px" pill
                        variant="primary" @click="load()">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="search" />
                        </div>
                        <b-tooltip target="pesquisarTarefaPedido" title="Localizar"></b-tooltip>
                    </b-button>

                    <b-button id="limparTarefaPedido" class="mr-2 my-2" size="sm" pill style="height: 20px"
                        @click="clearForm">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="eraser" />
                        </div>
                        <b-tooltip target="limparTarefaPedido" title="Limpar"></b-tooltip>
                    </b-button>
                </b-col>


            </b-form-row>

            <b-table responsive class="mt-2" small :busy="busy" :items="records" :fields="tableFields" hover show-empty>
                <template #empty>
                    <p>Nenhum item para ser exibido</p>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>



                <template v-slot:cell(departamentoSolicitante)="{ item }">
                    {{ item.sigla + ' - ' + item.descricao }}
                </template>
                <template v-slot:cell(tipoTarefaPedido)="{ item }">
                    <span @click="abrirDetalhe(item)" style="color: blue; cursor: pointer">{{
                        item.tipoTarefaPedido.descricao
                    }}</span>
                </template>

                <template v-slot:cell(actionButtons)="{ item }">
                    <div class="text-center">
                        <b-button id="iniciar" v-if="item.status.id === 127 && verificaPrivilegioTarefa(item)" pill
                            size="sm" variant="primary" title="Iniciar a tarefa atual..." @click="iniciarTarefa(item)">
                            <b-icon icon="file-earmark-play" />
                        </b-button>
                        <b-button v-if="
                            item.tipoTarefaPedido.id === 10 &&
                            item.status.id !== 127 &&
                            item.status.id !== 129
                            && verificaPrivilegioTarefa(item)
                        " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                            @click="abrirModalAlmoxarifadoModal(item)">
                            <b-icon icon="file-earmark-bar-graph" />
                        </b-button>

                        <b-button v-if="
                            (item.tipoTarefaPedido.id === 11 ||
                                item.tipoTarefaPedido.id === 13) &&
                            item.status.id !== 127 &&
                            item.status.id !== 129
                            && verificaPrivilegioTarefa(item)
                        " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                            @click="abrirModalSolicitanteModal(item)">
                            <b-icon icon="file-earmark-bar-graph" />
                        </b-button>

                        <b-button v-if="
                            item.tipoTarefaPedido.id === 12 &&
                            item.status.id !== 127 &&
                            item.status.id !== 129
                            && verificaPrivilegioTarefa(item)
                        " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                            @click="abrirModalLogin(item)">
                            <b-icon icon="file-earmark-bar-graph" />
                        </b-button>
                    </div>
                </template>
            </b-table>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                        totalPage
                    }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </b-card>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"
import Formatters from "@/core/mixins/formatters"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import TarefasAprovacaoAlmoxarifadoModal from "@/modules/almoxarifados/pedidos/TarefasAprovacaoAlmoxarifadoModal.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import TarefasAprovacaoSolicitanteModal from "./TarefasAprovacaoSolicitanteModal.vue"
import TarefaRetiradaModal from "./TarefaRetiradaModal.vue"
import ModalLogin from "./ModalLogin.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import TipoTarefaPedidoEnum from "@/core/utils/TipoTarefaPedidoEnum"

export default {
    mixins: [Formatters, ConfirmMixin, ListResourceMixin, FormResourceMixin],

    components: {
        TarefasAprovacaoAlmoxarifadoModal,
        LgFormInput,
        LgFormSelect,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageAlmoxarifado,
        LgFinderPagePessoa,
        TarefasAprovacaoSolicitanteModal,
        LgFinderPageProduto,
        TarefaRetiradaModal,
        ModalLogin,
    },

    props: {
        numeroPedido: String,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Pedidos",
        },

    },

    data() {
        return {
            isVisualizacao: false,
            usuarioAuthenticated: {},
            showTarefaAprovacaoAlmoxarifadoModal: false,
            showTarefaAprovacaoSolicitanteModal: false,
            showTarefaRetiradaModal: false,
            showModalLoginModal: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            form: {
                tarefa: { id: null, descricao: "Todos" },
                numeroTarefa: "",
                status: { id: 995, descricao: "Aguardando/Em Andamento" },
                departamentoResponsavel: {},
                almoxarifadoTarefa: {},
                numeroPedido: {},
                produto: {},
                departamentoSolicitante: {},
                responsavel: {},
                tipoStatusId: 37,
            },
            busy: false,
            records: [],
            selectedItem: {},
            statusOptions: [],
        }
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/tarefaspedido`)
        this.$statusService = new ResourceService(
            `/api/status/tipo/${this.form.tipoStatusId}`
        )
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$serviceTipoTarefaPedido = new ResourceService(`/api/tipotarefapedido`)
    },

    mounted() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamentoResponsavel = brand.departamento
        this.load();
    },

    watch: {

        page() {
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "id",
                    label: "Nº",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "pedido.id",
                    label: "Nº Pedido",
                    thStyle: "font-size: 16px; font-weight: 200; width: 10%",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "status.descricao",
                    label: "Status",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "departamentoSolicitante",
                    label: "Solicitante",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "destino",
                    label: "Destino",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "pedido.respCriacao",
                    label: "Responsável",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "tipoTarefaPedido",
                    label: "Tarefa",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "dataCriacao",
                    label: "Data",
                    tdClass: ["w-20", "text-center"],
                    thClass: ["w-20", "text-center"],
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    formatter: this.$formatDatetime,
                },
                {
                    key: "actionButtons",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
            ]
        },
    },

    methods: {
        temPrivilegioSelecionarUA() {
            return verificaPrivilegio(PrivilegiosEnum.PEDIDO_SELECIONAR_OUTRA_UA);
        },
        temPrivilegioConfigurarAlmoxarifado() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_ALMOXARIFADO);
        },
        verificaPrivilegioTarefa(tarefa) {
            if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.RETIRADA)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_ENTREGAR)
            else if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.APROVACAO_ALMOXARIFADO)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_APROVACAO);
            else if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.RECEBIMENTO)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_RECEBER);
            else
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_INCLUIR);
        },
        abrirDetalhe(item) {
            this.isVisualizacao = true
            if (item.tipoTarefaPedido.id == 10) {
                this.abrirModalAlmoxarifadoModal(item)
            }

            if (item.tipoTarefaPedido.id == 12) {
                this.selectedItem = item
                this.abrirModalRetirada(item)
            }

            if (item.tipoTarefaPedido.id == 11 || item.tipoTarefaPedido.id == 13) {
                this.abrirModalSolicitanteModal(item)
            }
        },

        fecharTarefaAprovacaoAlmoxarifado() {
            this.showTarefaAprovacaoAlmoxarifadoModal = false
            this.isVisualizacao = false
            this.load()
        },

        handleSelectProduto(item) {
            this.form.produto = item
            this.load()
        },

        async load() {
            const filtro = {}

            if (this.form.numeroTarefa && this.form.numeroTarefa != "") {
                filtro.id = this.form.numeroTarefa;
                filtro.pedidoId = this.form.numeroTarefa;

            }

            if (
                this.form.produto &&
                this.form.produto.id
            ) {
                filtro.produtoId = this.form.produto.id
            }

            if (
                this.form.almoxarifadoTarefa &&
                this.form.almoxarifadoTarefa.id
            ) {
                filtro.almoxarifadoId = this.form.almoxarifadoTarefa.id
            }

            if (
                this.form.departamentoResponsavel != undefined &&
                this.form.departamentoResponsavel.id != undefined &&
                this.form.departamentoResponsavel != ""
            ) {
                filtro.departamentoResponsavelId = this.form.departamentoResponsavel.id
            }

            if (
                this.form.departamentoSolicitante != undefined &&
                this.form.departamentoSolicitante.id != undefined &&
                this.form.departamentoSolicitante != ""
            ) {
                filtro.departamentoSolicitanteId = this.form.departamentoSolicitante.id
            }

            if (this.form.status) {
                filtro.statusId = this.form.status.id
            }
            if (
                this.form.responsavel &&
                this.form.responsavel.id !== ""
            ) {
                filtro.responsavel = this.form.responsavel.id
            }

            if (this.form.tarefa) {
                filtro.tipoTarefaId = this.form.tarefa.id
            }

            this.busy = true

            await this.$service
                .get("findTotalTarefasPaginaInicial")
                .then(response => {
                    this.$emit("pesquisouTarefas", response.data);
                });

            this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            })

        },

        clearForm() {
            this.form.status = { id: 995, descricao: "Aguardando/Em Andamento" }
            this.form.numeroTarefa = ""
            this.form.tarefa = { id: null, descricao: "Todos" }
            this.form.almoxarifadoTarefa = {}
            this.form.produto = {}
            const brand = JSON.parse(localStorage.getItem("context"))
            this.form.departamentoResponsavel = brand.departamento

            this.form.departamentoSolicitante = {}
            this.form.departamento = {}
            this.form.responsavel = {}
            this.form.tipoStatusId = 37
            this.params = {}
            this.load()
        },

        async listStatus({ filter, page = 1 }) {
            return this.$statusService
                .findAll({ filter, page, limit: 5 })
                .then(response => {
                    response.data.content.unshift({
                        id: 995,
                        descricao: "Aguardando/Em Andamento",
                    })
                    return response
                })
        },

        async listTipoTarefaPedido({ filter, page = 1 }) {
            return this.$serviceTipoTarefaPedido.findAll({ filter, page, limit: 5 })
        },

        async iniciarTarefa(item) {
            let response = await this.$confirm(
                `Deseja iniciar esta tarefa (${item.tipoTarefaPedido.descricao}) ?`
            )
            if (response) {
                item.status.id = 128
                item.status.descricao = "Em andamento"
                this.$service.save(item)
                this.isVisualizacao = false
                if (item.tipoTarefaPedido.descricao === "Aprovação do Almoxarifado") {
                    this.abrirModalAlmoxarifadoModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Recebimento") {
                    this.abrirModalSolicitanteModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Aprovação do Solicitante") {
                    this.abrirModalSolicitanteModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Retirada") {
                    this.abrirModalLogin(item)
                }
            } else {
                return
            }
        },

        abrirModalAlmoxarifadoModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoAlmoxarifadoModal = true
        },
        abrirModalSolicitanteModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoSolicitanteModal = true
        },

        abrirModalLogin(item) {
            this.selectedItem = item
            this.showModalLoginModal = true
        },

        abrirModalRetirada() {
            if (this.usuarioAuthenticated !== null) {
                this.showTarefaRetiradaModal = true
            }
        },

        async tarefaFinalizado() {
            this.isVisualizacao = false
            this.$emit("recarregarPedido", {})
            this.load()
        },

        tarefaAprovacaoSolicitanteFinalizado() {
            this.isVisualizacao = false
            this.showTarefaAprovacaoSolicitanteModal = false
            this.load()
        },

        tarefaRetiradaFinalizado() {
            this.isVisualizacao = false
            this.showTarefaRetiradaModal = false
            this.load()
        },

        handleSelectAlmoxarifadoTarefa(item) {
            this.form.almoxarifadoTarefa = item
            this.load();
        },
        handleSelectResponsavelTarefa(item) {
            this.form.responsavel = item
            this.load();

        },
        async handleSelectUnidadeAdministrativaTarefa(item) {
            this.form.departamentoResponsavel = item
            this.load();

        },
        async handleSelectUnidadeSolicitante(item) {
            this.form.departamentoSolicitante = item
            this.load();

        },
    },
}
</script>
<style>
.vs__selected {
    white-space: nowrap;
}
</style>
